var map = {
	"./basic_heal.svg": [
		99688,
		9688
	],
	"./blur.svg": [
		6838,
		6838
	],
	"./capture.svg": [
		32108,
		2108
	],
	"./collage.svg": [
		64460,
		4460
	],
	"./combine.svg": [
		72249,
		2249
	],
	"./crop.svg": [
		36539,
		6539
	],
	"./cutout.svg": [
		57073,
		7073
	],
	"./draw.svg": [
		38860,
		8860
	],
	"./eyes.svg": [
		80809,
		809
	],
	"./face.svg": [
		19415,
		9415
	],
	"./layouts.svg": [
		37240,
		7240
	],
	"./liquify_smile.svg": [
		70061,
		61
	],
	"./looks.svg": [
		71982,
		1982
	],
	"./makeup.svg": [
		5011,
		5011
	],
	"./patch_heal.svg": [
		21215,
		1215
	],
	"./photo_edit.svg": [
		86881,
		6881
	],
	"./scrapbook.svg": [
		90888,
		888
	],
	"./smooth.svg": [
		64961,
		4961
	],
	"./stickers.svg": [
		41873,
		1873
	],
	"./themes.svg": [
		42095,
		2095
	],
	"./tilt_face.svg": [
		64778,
		4778
	],
	"./twirl.svg": [
		41486,
		1486
	],
	"./video.svg": [
		78603,
		8603
	],
	"./vignette.svg": [
		12793,
		2793
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 73003;
module.exports = webpackAsyncContext;